import { init, fetchRestrictionStatus } from "@emcd-shared/restriction-service";
import { Request } from "@/api/request";
import { API } from "@/api/constants";
import { useUserStore } from "@/stores/user";

const restrictionApiAdapter = {
  async get(url) {
    const res = await Request.get(`${API.ENDPOINT}${url}`);
    if (!res.ok) throw new Error("[restriction] status request failed");
    return res.data;
  },
};

export const initRestrictions = async (app) => {
  // передаём app — пакет автопоказывает модалку onlyWithdrawals один раз за сессию,
  // как только fetchRestrictionStatus проставит state.onlyWithdrawals в true
  init({ api: restrictionApiAdapter, app });

  // Демо-режим / неудачная авторизация: токена нет, рестрикшенов у аккаунта нет
  if (!useUserStore().isAuth) return;

  try {
    await fetchRestrictionStatus();
  } catch (err) {
    console.error("[restriction] fetch error:", err);
  }
};
